var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#e82127"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m37.2159 15.3663c-4.6694-2.0439-9.2306-2.6936-13.2157-2.663h-.0005c-3.9851-.0306-8.5472.6191-13.2157 2.663-.5563-1.0126-.784-1.6267-.784-1.6267 5.1037-2.028 9.8836-2.7222 13.9997-2.7396 4.1163.0174 8.8964.7115 14.0008 2.7396 0 0-.1605.4986-.7846 1.6267zm-9.2975 1.5084-3.9173 22.1251-3.9488-22.1283c-3.7087.0027-4.885.4138-5.056 2.0923 0 0-2.5058-.9379-3.768-2.8428 4.9291-2.2942 9.8825-2.3977 9.8825-2.3977l2.8873 3.5318 2.8869-3.5313s4.9532.1035 9.883 2.3976c-1.2633 1.9049-3.768 2.8428-3.768 2.8428-.1701-1.6783-1.3478-2.0895-5.0816-2.0895z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.a9c3f1ef94e5d44e670153a056fa1d30.svg";
export { ForwardRef as ReactComponent };